const formatter = new Intl.NumberFormat('en-US', {
	currency: 'USD',
	minimumFractionDigits: 2,
	style: 'currency'
});

export default function (value) {
	return formatter.format(parseFloat(value));
}
